import script from "./HireAgreementPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./HireAgreementPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./HireAgreementPopUp.vue?vue&type=style&index=0&id=97d63128&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d63128"]])

export default __exports__